module.exports = __webpack_public_path__ + "img/iglu-globe-tail.36a669a9.png";